import axios from "../../../api/axios";

export const confirmAccount = async (data) => {
  const { account } = data;
  return await axios.post("/users/confirm-account", { account });
  
};
